import { render } from "./changePassword.vue?vue&type=template&id=bd2c0908&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=bd2c0908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2c0908"]])

export default __exports__